import { addDays, subDays } from "date-fns";
import { useActivitiesList } from "web_myplann/Activities/Hooks/useActivitiesList";
import {
	DASHBOARD_PAST_WINDOW_DAYS,
	DASHBOARD_UPCOMING_WINDOW_DAYS,
} from "web_myplann/Dashboard/constants";
import {
	dateFormatter,
	ISO_DATE_FORMAT,
} from "web_myplann/Shared/Utils/dateFormatters";

export const useDashboardActivities = (pageSize?: number) => {
	const currentDate = new Date();

	return useActivitiesList({
		upcomingUntil: dateFormatter(
			addDays(currentDate, DASHBOARD_UPCOMING_WINDOW_DAYS),
			ISO_DATE_FORMAT,
		),
		overdueFrom: dateFormatter(
			subDays(currentDate, DASHBOARD_PAST_WINDOW_DAYS),
			ISO_DATE_FORMAT,
		),
		includeResolvedEvents: false,
		pageSize,
	});
};
